import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./lib/i18n";

// Hero now uses an inline product mock (no large image), so no LCP preload
// is needed from the entry. The hero card paints as soon as the Index chunk
// hydrates.

createRoot(document.getElementById("root")!).render(<App />);
